import React from 'react';

interface CollectionContextProps {
    collectionId?: string;
}

export const CollectionContext = React.createContext<
    Partial<CollectionContextProps>
>({});
